const VIDEO_URL =
  "https://www.napolilounge.it/wp-content/uploads/2026/08/Napo1.mp4";

export default function HeaderVideo() {
  return (
    <div
      data-testid="header-video"
      className="fixed inset-0 overflow-hidden bg-sky-100"
    >
      <video
        data-testid="header-video-player"
        className="absolute inset-0 w-full h-full object-cover"
        src={VIDEO_URL}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
      />
    </div>
  );
}
